import { render, staticRenderFns } from "./QcentrisUnitRelation.vue?vue&type=template&id=2cde003c&scoped=true&"
import script from "./QcentrisUnitRelation.vue?vue&type=script&lang=js&"
export * from "./QcentrisUnitRelation.vue?vue&type=script&lang=js&"
import style0 from "./QcentrisUnitRelation.vue?vue&type=style&index=0&id=2cde003c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde003c",
  null
  
)

export default component.exports